import { useMemo } from 'react';
import { getViewport, useBounds } from '../useBounds';

type Return = {
  isSmallViewport: boolean;
  isMediumViewport: boolean;
  isLargeViewport: boolean;
  isStable: boolean;
};

export const useViewport = (): Return => {
  const { width } = useBounds();

  // Calculate viewport type synchronously from current width
  const { viewportType, isStable } = useMemo(() => {
    // Width of 0 indicates unstable state (iframe mounting, etc.)
    if (width === 0) {
      return {
        viewportType: 'small',
        isStable: false,
      };
    }

    return {
      viewportType: getViewport().viewportType,
      isStable: true,
    };
  }, [width]);

  return {
    isSmallViewport: viewportType === 'small',
    isMediumViewport: viewportType === 'medium',
    isLargeViewport: viewportType === 'large',
    isStable,
  };
};
